module.exports = __webpack_public_path__ + "static/media/user_placeholder.69d2ed55.jpg";